module.exports = new __parcel__URL__("leaderboard_mining_button_inactive.4a1a4410.png").toString();